import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block user-name text-left text-overflow-ellipsis" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "block" }



type LineAccountName = {
  customer_code: string;
  customer_name: string;
  account_name: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'name',
  props: {
    customer_code: null,
    customer_name: null,
    account_name: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.customer_code), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.customer_name || __props.account_name), 1)
  ]))
}
}

})